const selectNetworkParamsId = 'select_network';
const selectNetworkParamsIdRequester = 'select_network_requester';
const selectChangeSlaId = 'timing';
const selectOLOReqIntServices = 'olo_req_international_services';

const internationalCoordinatorGroups = [
  'VNO INCP Change Management',
  'SI: International Config & Testing',
  'PD: TX Implementation Co-Ord',
  'VODAFONE NS-Planning',
  'SI: Site Rationalisation Team',
  'VCNO: CORE GLOBAL TX',
  'VCNO: CORE GLOBAL TX 2nd Line',
  'Global TX Technical Support',
  'VCNO: CORE GLOBAL TX FON',
  'VCNO: CORE SHARP TX NOC',
  'SD: Satellite Operations',
  'VCNO: CABLE RESTORATION SUPPORT',
  'VCNO: Change Management (raised by INR team)',
  'International MSP',
  'VCNO: 3rd Line CORE IP & MSP',
  'VCNO: CORE IP & MSP',
  'VCNO: OPERATIONS MANAGERS',
  'VCNO: CORE IP & MSP Support',
  'VCNO: 3rd Line International Networks and Security',
  'VCNO: International Network Planning - IP Build',
  'Global Platform Change Management - Bangalore',
];

const fixedL3Approver = [
  'ACE L3 - Technology All',
  'ACE L3 - SO - Network Support',
];
const mobileL3Approver = [
  'ACE L3 - Technology All',
  'ACE L3 - Mobile Core, Fixed Voice and RAN',
  'ACE L3 - Fixed Voice Core',
  'ACE L3 - Configuration',
  'ACE L3 - CSDB (formally HLR)',
  'ACE L3 - Switching',
  'ACE L3 - CS Mobile Core',
  'ACE L3 - Messaging',
  'ACE L3 - NGIN',
  'ACE L3 - OCS',
  'ACE L3 - Roaming',
  'ACE L3 - Sure Signal',
  'ACE L3 - PS Core - IP Services, Paknet, and Paging',
  'ACE L3 - EMS',
  'ACE L3 - RAN',
  'ACE L3 - Transmission',
  'ACE L3 - Transport Operations',
  'ACE L3 - Cap Development, Tools and Capability',
  'ACE L3 - Property',
  'ACE L3- OSS',
];

export {
  selectNetworkParamsId,
  selectChangeSlaId,
  selectNetworkParamsIdRequester,
  selectOLOReqIntServices,
  internationalCoordinatorGroups,
  fixedL3Approver,
  mobileL3Approver,
};

